<template>
    <a v-if="href" :href="href" class="link-arrow" :class="additionalClasses">
        <ArrowCircle />
        <span v-html="text"></span>
    </a>
    <div v-else class="link-arrow" :class="additionalClasses">
        <ArrowCircle />
        <span v-html="text"></span>
    </div>
</template>

<script>
import ArrowCircle from '../../icons/ArrowCircle.vue'

export default {
    props: ['href', 'text', 'additionalClasses'],

    components: {
        ArrowCircle,
    },
};
</script>

<style lang="scss">
@import '../../../../scss/_variables';
@import '../../../../scss/_mixins';

.link-arrow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 18px;
    line-height: 21px;
    color: #000000;
    padding: 10px 5px 10px 0;
    font-weight: 400;
    transition: color ease 0.2s;

    &:hover {
        background: #f2f8ff;
        border-radius: 4px;
    }

    span {
        color: #000000;
    }

    svg {
        width: 22px;
        height: 22px;
        margin: 0 15px;
        transition: all ease 0.2s;
    }

    &--small {
        font-size: 14px;
        line-height: 22px;

        svg {
            width: 17px;
            height: 17px;
            margin-left: 15px;
        }

        &:hover {
            svg {
                width: 21px;
                height: 21px;
                margin-left: 13px;
            }
        }
    }

    &--big {
        font-size: 28px;
        line-height: 36px;

        svg {
            min-width: 33px;
            height: 33px;
            margin-left: 15px;

            @include min-width-769 {
                margin-left: 25px;
            }
        }

        &.link-arrow--left {
            svg {
                margin-left: 0;
                margin-right: 15px;

                @include min-width-769 {
                    margin-right: 25px;
                }
            }
        }

        &:hover {
            svg {
                width: 33px;
                height: 33px;
                margin-left: 15px;

                @include min-width-769 {
                    margin-left: 25px;
                }
            }

            &.link-arrow--left {
                svg {
                    margin-left: 0;
                    margin-right: 15px;

                    @include min-width-769 {
                        margin-right: 25px;
                    }
                }
            }
        }
    }

    &--center {
        justify-content: center;
    }

    &--right {
        justify-content: flex-end;
    }

    &--left {
        svg {
            order: -1;
            margin-left: 0;
            margin-right: 12px;
            transform: rotate(180deg);
        }

        &:hover {
            svg {
                margin-right: 10px;
                margin-left: -2px;
            }
        }
    }
}

.header .link-arrow {
    background: #F0ECFB;
    border-radius: 15px;
    justify-content: center;

    &:hover {
        background: #D7CDF3;
    }

    .icon-arrow-circle {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/partials/LinkArrow.vue